import styled from 'styled-components';
import { colors } from '../Colors';
import { Severity } from '../types/severity';

export const Container = styled.div<{ $type: Severity }>`
    display: flex;
    flex-direction: column;
    gap: 6px;
    width: 100%;
    padding: ${({ $type }) => $type && colors[$type] ? '12px' : '12px 0'};
    border-radius: 10px;
    background-color: ${({ $type }) => $type && colors[$type] ? `${colors[$type]}33` : 'transparent'};

`;

export const Title = styled.p`
    margin: 0;
    font-size: 15px;
    font-weight: 700;
    color: #232323;
    white-space: pre-wrap;
    font-family: 'Inter', sans-serif;
`;

export const Description = styled.p`
    margin: 0;
    font-size: 12px;
    font-weight: 400;
    color: #232323;
    white-space: pre-wrap;
    font-family: 'Inter', sans-serif;
`;

export const ListItem = styled.p`
    margin: 0;
    font-size: 13px;
    font-weight: 400;
    color: #232323;
`;

export const Heading = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
`;